export const CPF_MASK = { mask: '###.###.###-##' };
export const CNPJ_MASK = { mask: '##.###.###/####-##' };
export const DOCUMENT_MASK = { mask: [CPF_MASK.mask, CNPJ_MASK.mask] };
export const DATE_MASK = { mask: '##/##/####' };
